import React, { useState } from "react";
import { CommonModal } from "../../AbstractElements";
import { Row, Col } from "reactstrap";
import { tmsApi } from "../../api";
import axios from 'axios';
import { showAlert } from "../../Services/Shared.service";

const QrGenerationModal = ({ Large, title, LargeModaltoggle, carObj, fetchData }) => {

    const [selectedLanguage, setSelectedLanguage] = useState('english');

    const handleLanguageChange = (event) => {
        setSelectedLanguage(event.target.value);
    };

    const handleSubmit = () => {
        console.log(">>>>>>>Car Obj Id is ::::: ", carObj.id)

        const dataList = [carObj.id]
        const config = {
            headers: {
                token: `${localStorage.getItem('token')}`,
                "Access-Control-Allow-Origin": "*",
                'Content-Type': 'application/json'
            },
        };

        axios.post(tmsApi + "v1/entities/cars/qr-code/generate", dataList, config)
            .then(response => {
                console.log("Generate API Response :: ", response)
                showAlert('success', "QR Code has been generated successfully!")
                LargeModaltoggle();
                fetchData();
            })
            .catch(err => {
                console.error(err);
                showAlert('error', err.response?.data?.message
                    ? err.response.data.message : 'Something went wrong')
            });
    };

    return (
        <CommonModal
            isOpen={Large}
            title={title}
            toggler={LargeModaltoggle}
            size="md"
        >
            <Row className="driver-push-notification">
                <Col xl="12" className="push-botification-body">
                    <div className="text-center"> Please select your preferred language for QR code generation:</div>
                </Col>
                <Col xl="12">
                    <div className="CheckBox" style={{ display: "flex", justifyContent: "center", margin: "2%" }}>
                        <select value={selectedLanguage} onChange={handleLanguageChange} 
                            style={{ width: "12vw", height: "4vw", fontSize: "1.5vw", padding: "0.5vw"}}
                        >
                            <option value="english">English</option>
                            {/* <option value="hindi">Hindi</option> */}
                        </select>

                    </div>
                </Col>
                <Col xl="12" className="push-notification-footer">
                    <button
                        className="btn btn-primary"
                        type="submit"
                        onClick={() => handleSubmit()}
                    >
                        Confirm
                    </button>
                </Col>
            </Row>
        </CommonModal>
    );
};

export default QrGenerationModal;
